import { useEffect } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import { Box, Grid, media, xcss } from "@atlaskit/primitives";
import { TwcBackground } from "@atlassian/product-wireframes";

import { useSearchParameters } from "@/components/signup/hooks";
import { LayoutVersion } from "@/components/signup/layouts";
import { Modal } from "@/components/signup/layouts/modal";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { JiraOverlay } from "./jira-overlay";
import LeftHandSide from "./left-hand-side";
import RightHandSide from "./right-hand-side";
import { getTeamTypeWithFlow } from "./utils";

const WorkOnFirstView = () => {
    const { teamType } = useSearchParameters();
    const teamTypeValue = getTeamTypeWithFlow(teamType);
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const isTwcOverlay = checkFeatureFlagGate(
        featureFlags.cfind5480TwcSignupOverlay
    );
    const isMobileResponsive = checkFeatureFlagGate(
        featureFlags.cfindWorkOnFirstMobileResponsive
    );

    useEffect(() => {
        createAnalyticsEvent({
            action: "viewed",
            eventType: "screen",
            name: "workOnFirstScreen",
            attributes: {
                teamType: teamTypeValue
            }
        }).fire();
    }, []);

    if (isTwcOverlay) {
        return (
            <TwcBackground>
                <Modal
                    size="lg"
                    showBrandFooter={false}
                    version={LayoutVersion.V3}
                    showProductLogoOnLargeScreens={true}
                >
                    <Box
                        xcss={isMobileResponsive ? responsiveWrapper : wrapper}
                    >
                        <Grid
                            gap="space.0"
                            xcss={
                                isMobileResponsive
                                    ? responsiveGridStyles
                                    : gridStyles
                            }
                        >
                            <LeftHandSide
                                teamType={teamTypeValue}
                                isMobileResponsive={isMobileResponsive}
                            />
                            {isMobileResponsive ? (
                                <Box xcss={rightHandSideWrapper}>
                                    <RightHandSide teamType={teamTypeValue} />
                                </Box>
                            ) : (
                                <RightHandSide teamType={teamTypeValue} />
                            )}
                        </Grid>
                    </Box>
                </Modal>
            </TwcBackground>
        );
    }

    return (
        <JiraOverlay isMobileResponsive={isMobileResponsive}>
            <Grid
                gap="space.0"
                xcss={isMobileResponsive ? responsiveGridStyles : gridStyles}
            >
                <LeftHandSide
                    teamType={teamTypeValue}
                    isMobileResponsive={isMobileResponsive}
                />
                {isMobileResponsive ? (
                    <Box xcss={rightHandSideWrapper}>
                        <RightHandSide teamType={teamTypeValue} />
                    </Box>
                ) : (
                    <RightHandSide teamType={teamTypeValue} />
                )}
            </Grid>
        </JiraOverlay>
    );
};

const gridStyles = xcss({
    width: "100%",
    height: "100%",
    gridTemplateColumns: "50% 50%"
});

const responsiveGridStyles = xcss({
    width: "100%",
    height: "100%",
    gridTemplateColumns: "100%",
    [media.above.md]: {
        gridTemplateColumns: "50% 50%"
    }
});

const rightHandSideWrapper = xcss({
    display: "none",
    [media.above.md]: {
        display: "block"
    }
});

const wrapper = xcss({
    width: "100%",
    maxWidth: "1140px",
    height: "640px",
    overflow: "hidden"
});

const responsiveWrapper = xcss({
    width: "100%",
    maxWidth: "1140px",
    height: "auto",
    overflow: "hidden",
    [media.above.md]: {
        height: "640px"
    }
});

export default WorkOnFirstView;
